const termsUrl = `${process.env.REACT_APP_PLINK_TERMS_URL}`;
const privacyUrl = `${process.env.REACT_APP_PLINK_PRIVACY_URL}`;
const faqUrl = `${process.env.REACT_APP_PLINK_FAQ_URL}`;
const mapUrl = `${process.env.REACT_APP_PLINK_MAP_URL}`;
const earningUrl = `${process.env.REACT_APP_PLINK_EARNING_URL}`;
const nominateUrl = `${process.env.REACT_APP_PLINK_NOMINATE_URL}`;

export const links = {
  terms: `${termsUrl}`,
  privacy: `${privacyUrl}`,
  faq: `${faqUrl}`,
  businessMap: `${mapUrl}`,
  earning: `${earningUrl}`,
  nominate: `${nominateUrl}`
};

export const routes = {
  home: 'home',
  wallet: 'wallet',
  rewards: 'rewards',
  more: 'more',
  storesHome: 'home/stores/:storeId',
  storeInfoHome: 'home/stores/:storeId/info',
  storeCampaignsHome: 'home/stores/:storeId/campaigns/:campaignId',
  walletCampaignsHome: 'wallet/:storeId/:campaignId',
  howPlinkWorks: 'more/how-plink-works',
  findBusiness: 'more/find-business',
  connectAccountAndReturnRoute:
    '/tabs/more/connect-account/:action/:storeId/:campaignId',
  connectAccount: '/tabs/more/connect-account',
  nominateBusiness: 'more/nominate-business',
  faqs: 'more/faqs',
  howFancoinsWork: 'more/how-fancoins-work',
  privacyPolicy: 'more/privacy-policy',
  howPlinkWorksRewards: 'rewards/how-plink-works',
  accountInfo: '/tabs/account-info',
  consumerName: 'account-info/consumer-name',
  consumerEmail: 'account-info/consumer-email',
  consumerPassword: 'account-info/consumer-password',
  consumerBirthday: 'account-info/consumer-birthday',
  accountInfoBack: '/tabs/account-info',
  loadingProgram: '/loading-program'
};

export const plaidReturnRoutes = {
  storesHome: `/tabs/${routes.storesHome}`,
  storeCampaignsHome: `/tabs/${routes.storeCampaignsHome}`,
  walletCampaignsHome: '/tabs/wallet/:storeId/:campaignId',
  home: '/tabs/home'
};

export const shortDeviceMaxHeight = '570px';
